// src/main.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/queryClient"; // adjust path if needed
import { BrowserRouter, HashRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import { store } from './store';

// Detect Electron: file://, app:// (custom protocol), or userAgent
const isElectron = 
  window.location.protocol === 'file:' || 
  window.location.protocol === 'app:' ||
  navigator.userAgent.toLowerCase().includes('electron');

// Use HashRouter for Electron (file:// protocol doesn't work with BrowserRouter)
const Router = isElectron ? HashRouter : BrowserRouter;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <Router>
          <App />
        </Router>
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>
);